import React, { useEffect, useMemo, useState } from "react";
import "./About_Multiple_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import Green_Animated_Btn from "../../../common_components/common_btn/green_animated_btn/Green_Animated_Btn";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Common_Multiple_Banner from "../../../common_components/common_multiple_banner/Common_Multiple_Banner";
import { BannersIDS, commonBannerApi } from "../../../../utils/commonBannerApi";

const About_Multiple_Banner = () => {

   const [imgSrc, setImgSrc] = useState([]);
  
    const getBanners = async () => {
      try {
        const res = await commonBannerApi(BannersIDS.AUSubMainBanners);
        if (res?.success) {
          setImgSrc(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };
  
    useEffect(() => {
      getBanners();
    }, []);
  
    const imgSrcNew = useMemo(() => imgSrc.map((item) => item?.image), [imgSrc]);

  return (
    <section className="About_Multiple_Banner">
      <div className="container">
        <div className="main_content_div">
          <Common_Multiple_Banner
            imgSrc={imgSrcNew}
            breakpoints={{
              0: {
                slidesPerView: 1,
                // spaceBetween: 10,
              },
              360: {
                slidesPerView: 1,
                // spaceBetween: 10,
              },
              567: {
                slidesPerView: 1.5,
                // spaceBetween: 10,
              },
              767: {
                slidesPerView: 1.8,
                // spaceBetween: 10,
              },
              860: {
                slidesPerView: 2.2,
                // spaceBetween: 10,
              },
              1024: {
                slidesPerView: 2.2,
                spaceBetween: 10,
                // spaceBetween: 10,
              },
            }}
          />

          {/* <Swiper
            spaceBetween={10}
            // slidesPerView={7}
            loop={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
                // spaceBetween: 10,
              },
              360: {
                slidesPerView: 1,
                // spaceBetween: 10,
              },
              567: {
                slidesPerView: 1.5,
                // spaceBetween: 10,
              },
              767: {
                slidesPerView: 1.8,
                // spaceBetween: 10,
              },
              860: {
                slidesPerView: 2.2,
                // spaceBetween: 10,
              },
              1024: {
                slidesPerView: 2.2,
                spaceBetween: 10,
                // spaceBetween: 10,
              },
            }}
          >
            <SwiperSlide>
              <div className="slider_banner_div">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Images/about_us/multiple_banner/img1.png"
                  }
                  className="slider_img"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="slider_banner_div">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Images/about_us/multiple_banner/img2.png"
                  }
                  className="slider_img"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="slider_banner_div">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Images/about_us/multiple_banner/img3.png"
                  }
                  className="slider_img"
                />

                <div className="btn_holder">
                  <Green_Animated_Btn
                    btn_name="Create Account"
                    rightIcon={faArrowRight}
                  />
                </div>
              </div>
            </SwiperSlide>
          </Swiper> */}
        </div>
      </div>
    </section>
  );
};

export default About_Multiple_Banner;
